import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import { useGetProductsQuery } from "../../features/CallApi";
import LoadScreen from "../UI/LoadScreen";
import { ProductAdd } from "./ProductAdd";
import { ProductList } from "./ProductsList";

export const Products = () => {
    const navigate = useNavigate();
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize] = useState(10);
    const [stringFilter, setStringFilter] = useState("");
    const { isLoading, data, refetch, error } = useGetProductsQuery({ pageIndex, pageSize, stringFilter });

    useEffect(() => {
        refetch()
    },[null])

    return (
        <Container>
            <h3>Товаров</h3>
            <ProductAdd refetch={refetch} />
            {error ?
                <div></div>
                :
                <div>
                    <div className="d-flex">
                        <input type={`text`} id="stringFilter" onChange={
                            (e) => setTimeout(() => { setStringFilter(e.target.value)
                            setPageIndex(1)
                            }, 2000)}
                            placeholder="Поиск.." name="stringFilter" className="form-control" />
                    </div>
                    {isLoading ?
                        <LoadScreen />
                        :
                        <ProductList pageIndex={pageIndex} setPageIndex={setPageIndex} navigate={navigate} products={data.getProducts} totalPages={data.totalPages} />
                    }
                </div>
            }
        </Container>
    )
}